import Empty from './Empty'

export default Empty
